<div>
    <mat-dialog-content>
        <div class="header">
            <div class="title {{cssClass}}" *ngIf="title != 'Information'">
                @if (cssClass == 'success-snackbar' || title == 'Rejected Successfully') {
                    <img src="/assets/icons/Badgegreen-check.svg"  alt="green badge check" />
                } @else {
                    <img src="/assets/icons/red-Badge.svg" alt="red badge"  />
                }
                
                
                {{title}}
            </div>
            <div class="title-info"  *ngIf="title == 'Information'">
                <img src="/assets/icons/Info_Icon_2.svg"  alt="info icon" />
                
                {{title}}
            </div>

            <div>
                <img src="/assets/icons/Close-new.svg" (click)="onConfirmClick()" alt="close" />
            </div>
        </div>
        <div class="message" style="max-height: 55px; overflow: auto;" [title]="message" [innerHTML]="message"></div>
    </mat-dialog-content>
</div>

